<template>
  <div
    class="logo"
    :class="{'logo--light': isLight }"
  >
    <img
      v-if="isLight"
      class="responsive-logo-sidebar no-top-margin"
      src="../../assets/NATA_Visual_1.png"
    >
    <a
      v-else
      target="_blank"
      href="https://www.accreditationmatters.com.au/am2025"
    >
      <img
        class="responsive-logo"
        src="../../assets/NATA_Visual_0.png"
      >
    </a>
  </div>
</template>
<script>
  export default {
    props: {
      isLight: {
        type: Boolean,
        default: false
      },
      isLandscape: {
        type: Boolean,
        default: false
      },
      isPortrait: {
        type: Boolean,
        default: false
      }
    },
  };
</script>
<style lang="scss">
	@import "../../styles/shared/shared";
  .responsive-logo {
    width: 100%;
    max-width: 500px;
    height: auto;
  }
  .responsive-logo-sidebar {
    width: 100%;
    height: auto;
    @include maxpoint(tablet) {
      margin-top: 0px;
    }
    @include minpoint(tablet) {
      margin-top: 30px;
      max-width: 240px;
    }
  }
  .no-top-margin {
    margin-top: 0px;
  }
	.logo {
		&__landscape {
			@include minpoint(tablet) {
				display: none;
			}
		}
		&__portrait {
			@include maxpoint(phone) {
				display: none;
			}
		}
		&__fill {
			fill: #00257b;
		}
		&--light &__fill {
			fill: $white;
		}
	}
</style>
